<template>
  <div class="comment-history">
    <CommentHistoryContent
      :comment="currentComment"
      :comments="comments"
      :demoVideoId="comment.demoVideoId"
      :demoVideoVersionMap="demoVideoVersionMap"
      :projectScoped="projectScoped"
    >
      <template #after>
        <button
          class="link is-medium-500 comment__view-changes-link"
          @click="onShowModal"
        >
          View what was changed
        </button>
      </template>
    </CommentHistoryContent>
    <Teleport to="body">
      <ModalCommentChanged
        :comment="comment"
        :comments="comments"
        :demoVideoVersionMap="demoVideoVersionMap"
        :projectScoped="projectScoped"
      />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import CommentHistoryContent from "@/components/Comment/CommentContent/CommentHistoryContent.vue"
import ModalCommentChanged from "@/components/Modal/ModalCommentChanged.vue"

import { Comment } from "@/models"
import { useModal } from "@/plugins/vue-js-modal/index"

import type { DemoVideoVersionInfo } from "@/composables/useDemoVideo"

const props = defineProps({
  comment: {
    required: true,
    type: Object as () => Comment
  },
  comments: {
    required: true,
    type: Array as () => Comment[]
  },
  demoVideoVersionMap: {
    default: () => ({}),
    type: Object as () => Record<string, DemoVideoVersionInfo>
  },
  projectScoped: {
    type: Boolean,
    default: true
  }
})

const modal = useModal()

const currentComment = computed(() => {
  return props.comment.commentAuditRecord?.after ?? props.comment
})

const onShowModal = () => modal.show(`comment-changed-${props.comment.id}`)
</script>
